(function () {
    'use strict';

    angular
        .module('app.tenants')
        .controller('TenantsListController', TenantsListController);

    TenantsListController.$inject = ['common', 'dataservice', 'bootstrap.dialog', 'config', '$http'];
    /* @ngInject */
    function TenantsListController(common, dataservice, bsDialog, config, $http) {
        var vm = this;
        vm.TotalAmount = 0;
        vm.TotalNumberOfUsers = 0;
        vm.TotalCustomers = 0;
        vm.TotalInstalls = 0;
        vm.DailyActiveUsers = 0;
        vm.RemainingAmount = 0;
        vm.OpsAmount = 0;
        vm.OtherAmount = 0;
        vm.OurApiCount = 0;
        vm.PSApiCount = 0;
        vm.R25Count = 0;
        vm.AdAstraCount = 0;
        vm.MazevoCount = 0;
        vm.TotalLicensedUsers = 0;
        vm.TotalEventDisplays = 0;
        vm.TotalPaymentTemplates = 0;
        vm.title = 'Tenants';
        vm.displayedItems = [];
        vm.items = [];
        vm.rowClass = rowClass;
        vm.getApiVersion = getApiVersion;
        vm.hideApiGet = hideApiGet;
        vm.getEmsDbVersion = getEmsDbVersion;
        vm.hideEmsDbGet = hideEmsDbGet;
        vm.currentOutgoingIp = "";
        vm.showInactive = false;
        vm.emailToUnlock = "";
        vm.unlockUser = unlockUser;

        activate();

        function activate() {
            var promises = [common.checkIsAdmin(), getItems(), getIp()];
            return common.$q.all(promises).then(function (data) {
                common.logger.info('Activated ' + vm.title + ' View');
            }, function (error) { });
        }

        function getIp() {
            return dataservice.getItem("api/Tenants/OutGoingIP").then(function (response) {
                vm.currentOutgoingIp = response.data;
            }, function (error) { })
        }

        function getItems() {
            return dataservice.getItems('api/Tenants').then(function (response) {
                var thisYear = (new Date()).getFullYear();
                var nextYear = thisYear + 1;
                var endOfYear = moment(new Date("1/1/" + nextYear));
                var today = moment();
                var data = response.data;
                for (var i = 0; i < data.length; i++) {
                    if (data[i].DataApiUrl) {
                        data[i].HasApi = true;
                    }
                    else {
                        data[i].HasApi = false;
                    }
                }
                vm.items = data;
                vm.displayedItems = [].concat(vm.items);
                
                for (var i in data) {
                    var expireUtc = moment.utc(data[i].ActiveUntilUtc);
                    
                    var a = data[i].Amount || 0;
                    if(a > 0) {
                        vm.TotalCustomers++;
                        vm.TotalLicensedUsers += data[i].NumberOfUsers;
                        vm.TotalEventDisplays += data[i].NumberOfDisplayTemplates;
                        vm.TotalPaymentTemplates += data[i].NumberOfPaymentTemplates;
                    }

                    if (expireUtc.isBefore(endOfYear) && expireUtc.isAfter(today)) {
                        vm.RemainingAmount += parseFloat(a);
                    }

                    if (data[i].ID != 1) {
                        vm.OpsAmount += parseFloat(a);
                    }
                    else {
                        vm.OtherAmount += parseFloat(a);
                    }

                    

                    vm.TotalAmount += parseFloat(a);
                    vm.TotalNumberOfUsers += parseFloat(data[i].CountOfUsers);
                    vm.DailyActiveUsers += parseFloat(data[i].DailyActiveUsers);
                    if (data[i].DataApiUrl) {
                        vm.TotalInstalls++;

                        switch (data[i].ApiType) {
                            case "CollegeNet API":
                                vm.R25Count++;
                                break;
                            case "Seven Point EMS API":
                                vm.OurApiCount++;
                                break;
                            case "Ad Astra API":
                                vm.AdAstraCount++;
                                break;
                            case "EMS API":
                                vm.PSApiCount++;
                                break;
                            case "Mazevo API":
                                vm.MazevoCount++;
                                break;
                        }

                    }
                }
                vm.AnnualAmount = vm.TotalAmount;
                vm.RemainingAmount = vm.RemainingAmount;
                return vm.items;
            }, function (error) { });
        }

        function rowClass(item) {
            var activeUntil = moment(item.ActiveUntilUtc);
            var amount = item.Amount;

            if (amount > 0) {
                if (activeUntil < moment().add(1, 'month')) {
                    return { 'background-color': '#ffb0b0' }
                }
            }
            else {
            
                if (activeUntil.isSame("2000-01-01") || activeUntil.isSame("2016-01-01")) {
                    return { 'background-color': '#edeefc' }
                }
                if (activeUntil < moment().add(1, 'month')) {
                    return { 'background-color': '#f2f259' }
                }
            }
         
        }

        function getApiVersion(item) {
            dataservice.getItems('api/Tenants/ApiVersion/' + item.ID).then(function (response) {
                item.ApiVersion = response.data.Message;
            }, function (error) { })
        }

        function unlockUser() {
            if (vm.emailToUnlock) {
                var dto = {
                    emailToUnlock: vm.emailToUnlock
                };
                dataservice.saveItem('api/Tenants/UnlockUser', dto, true).then(function (response) {
                    
                    if (response.data.Success) {
                        common.logger.success("User Unlocked");
                    }
                    else {
                        common.logger.warning("User not found", null, "Warning", true);
                    }
                }, function (error) { })
            }
        }

        function getEmsDbVersion(item) {
            dataservice.getItems('api/Tenants/EmsDbVersion/' + item.ID).then(function (response) {
                item.EmsDbVersion = response.data.Message;
            }, function (error) { })
        }

        function hideApiGet(item) {
            if (item.ApiVersion)
                return true;
            if (!item.DataApiUrl)
                return true;

            return false;
        }


        function hideEmsDbGet(item) {
            if (item.EmsDbVersion)
                return true;
            if (!item.DataApiUrl)
                return true;

            return false;
        }
        
    }
})();
